module.exports = __webpack_public_path__ + "static/media/微波目标特性测量实验室3.26059d91.jpg";